import { defineMessages, useIntl } from 'react-intl';

import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';

import { BROWSER_SUPPORT_ARTICLE_URL } from '../constants';
import { useLegacyBrowserBanner } from '../hooks/useLegacyBrowserBanner';

const messages = defineMessages({
  text: {
    id: 'LegacyBrowserBanner.message',
    defaultMessage:
      'Your browser version is out of date. To ensure the best performance and security, please update to a supported version.',
    description:
      'Body for the persistent banner shown on partially supported browsers',
  },
  linkText: {
    id: 'LegacyBrowserBanner.linkText',
    defaultMessage: 'View System Requirements',
    description:
      'Link to the system requirements article from the outdated-browser banner',
  },
});

export function LegacyBrowserBanner() {
  const intl = useIntl();
  const shouldShow = useLegacyBrowserBanner();

  if (!shouldShow) {
    return null;
  }

  return (
    <StatusMessage
      ariaLive="polite"
      link={{
        external: true,
        href: BROWSER_SUPPORT_ARTICLE_URL,
        text: intl.formatMessage(messages.linkText),
      }}
      message={intl.formatMessage(messages.text)}
      mode="banner"
      status="warning"
    />
  );
}
